import parseUnits from '#/utils/parseUnits';
import { ethers } from 'ethers';
import { useMemo } from 'react';
import useNetworks from './useNetworks';
import useWatcherNetworks from './useWatcherNetworks';
import useWatcherPriceList from './useWatcherPriceList';

/**
 * useTotalPortfolioValue
 *
 * USD always use 8 decimal
 */
export default function useTotalPortfolioValue() {
  const { data: watcherNetworksData } = useWatcherNetworks();
  const { data: networksData } = useNetworks();
  const { data: watcherPriceInfoData } = useWatcherPriceList();
  const totalAsBigNumber = useMemo(() => {
    return watcherNetworksData?.data.data &&
      networksData?.data?.data &&
      watcherPriceInfoData?.data?.data
      ? watcherNetworksData.data.data.reduce((acc, current) => {
          const { decimal } = networksData.data.data?.find(
            item => item.symbol === current.symbol
          )!;
          const { price } = watcherPriceInfoData.data.data?.find(
            item => item.symbol === current.symbol
          )!;
          const itemTotalAsBigNumber = ethers.BigNumber.from(
            current.totalDelegated
          )
            // without totalReward
            // .add(ethers.BigNumber.from(current.totalReward))
            .mul(parseUnits(price, 8))
            .div(ethers.BigNumber.from('10').pow(decimal));
          return acc.add(itemTotalAsBigNumber);
        }, ethers.constants.Zero)
      : ethers.constants.Zero;
  }, [watcherNetworksData, networksData, watcherPriceInfoData]);
  return totalAsBigNumber;
}
export function useTotalPortfolioValueIsLoading() {
  const { isLoading: isWatcherNetworksLoading } = useWatcherNetworks();
  const { isLoading: isNetworksLoading } = useNetworks();
  const { isLoading: isWatcherPriceListLoading } = useWatcherPriceList();
  return (
    isWatcherNetworksLoading || isNetworksLoading || isWatcherPriceListLoading
  );
}
